
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Container } from "@/components/ui/container";
import FAQSection from "@/components/help/FAQSection";
import SupportForm from "@/components/help/SupportForm";
import HowItWorksSection from "@/components/home/HowItWorksSection";

const HelpCenterPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Container>
          <div className="py-12">
            <h1 className="text-3xl font-bold mb-8 text-reagent-blue">Help Center</h1>
            
            <Tabs defaultValue="faq" className="w-full">
              <TabsList className="grid w-full grid-cols-3 mb-8">
                <TabsTrigger value="faq">FAQ</TabsTrigger>
                <TabsTrigger value="how-it-works">How It Works</TabsTrigger>
                <TabsTrigger value="support">Support</TabsTrigger>
              </TabsList>
              
              <TabsContent value="faq">
                <FAQSection />
              </TabsContent>
              
              <TabsContent value="how-it-works">
                <HowItWorksSection />
              </TabsContent>
              
              <TabsContent value="support">
                <div className="max-w-3xl mx-auto">
                  <h2 className="text-2xl font-semibold mb-4">Get Support</h2>
                  <p className="text-gray-600 mb-8">
                    Having trouble with LabSwapp? Fill out the form below, and our support team will help you resolve the issue.
                  </p>
                  <SupportForm />
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default HelpCenterPage;
